import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e46780ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewport pt_10" }
const _hoisted_2 = ["innerHTML"]

import { RouteLocationNormalizedLoaded, useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'
import { useSite2Station } from '@/store'
import { Term } from '@/common/const'
import { getEffectTermByType } from '@/apis/login'
import axios from 'axios'
import { ElLoading, ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stationCode = useSite2Station()
const route: RouteLocationNormalizedLoaded = useRoute()
const html = ref('')

const fetchText = (url: string) => axios.get(url)
onMounted(async () => {
  // 路由中的条款类型
  const primitiveType: 'agreement' | 'policy' = route.path.split('/').pop() as 'agreement' | 'policy'
  // 后端的枚举
  const termType: Term = {
    agreement: Term.utilize,
    policy: Term.privacy
  }[primitiveType]
  const instance = ElLoading.service()
  try {
    const termlist = await getEffectTermByType({
      stationCode,
      type: termType
    })

    const textData = await fetchText(termlist.data[0].fileUrl)

    html.value = textData.data
  } catch (error) {
    ElMessage.error('获取文件内容失败')
  } finally {
    instance.close()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_empty, { "image-size": 200 }, null, 512), [
      [_vShow, !html.value]
    ]),
    _createElementVNode("div", { innerHTML: html.value }, null, 8, _hoisted_2)
  ]))
}
}

})